export const disclosureCellStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '8px',
};

export const documentsCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
};

export const expandIconStyles = {
  display: 'flex',
  color: ({ palette }) => palette.text.secondary,
};
